import { CommonDataServiceEntityDataset } from 'app/model/dataset/common-data-service.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { Metamodel } from 'app/model/base/model';
import { DynamicsSink } from './dynamics.copysink';

@Metamodel.model({
    name: adfModelTypeMap.commonDataService.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(CommonDataServiceEntityDataset) }
})
export class CommonDataServiceSink extends DynamicsSink {
}
